const translationEng = {
  //About us Translation
  'About Us': 'About Us',
  'MyCookAround is a new social platform and a market place, which connects Cooks and Guests according to sections, searching and location. The Cooks sell their farm products, warm homemade meals, homemade products, wine, fruits, vegetables, surpluses from their gardens but also experiences such as wine growing or cooking classes. MyCookAround connects people and brings economical benefits for the Cooks and the Guests.':
    'MyCookAround is a new social platform and a market place, which connects Cooks and Guests according to sections, searching and location. The Cooks sell their farm products, warm homemade meals, homemade products, wine, fruits, vegetables, surpluses from their gardens but also experiences such as wine growing or cooking classes. MyCookAround connects people and brings economical benefits for the Cooks and the Guests.',
  //FAQ Translation
  'How do I use MyCookAround?': 'How do I use MyCookAround?',
  'What are MyCookAround policies?': 'What are MyCookAround policies?',
  'Who can be a Cook?': 'Who can be a Cook?',
  'What do I need to create a Cook’s profile?':
    'What do I need to create a Cook’s profile?',
  'What kind of photo should I upload in my profile?':
    'What kind of photo should I upload in my profile?',
  'When will my Offers go online?': 'When will my Offers go online?',
  'What do I get for the membership I pay to MyCookAround?':
    'What do I get for the membership I pay to MyCookAround?',
  'How many portions/events/items/kilograms can I sell?':
    'How many portions/events/items/kilograms can I sell?',
  'Do I have to sell only main courses as a home Cook?':
    'Do I have to sell only main courses as a home Cook?',
  'As a home Cook should I sell only one meal or serve the whole menu?':
    'As a home Cook should I sell only one meal or serve the whole menu?',
  'As a home Cook What if I am not interested in social dining but I only want to sell meals?':
    'As a home Cook: What if I am not interested in social dining but I only want to sell meals?',
  'What if I want to sell my Offers as a home Cook at my place but I only have limited time to spend with my Guests?':
    'What if I want to sell my Offers as a home Cook at my place but I only have limited time to spend with my Guests?',
  'How do I set the price?': 'How do I set the price?',
  'How much money can I make on MyCookAround as a Cook?':
    'How much money can I make on MyCookAround as a Cook?',
  'As a Cook, how do I deal with Orders I get?':
    'As a Cook, how do I deal with Orders I get?',
  'Is there any way how I can increase my profit as a home Cook?':
    'Is there any way how I can increase my profit as a home Cook?',
  'If I am paid via Platform MyCookAround and want to avoid unnecessary bank transfer fees, how do I do it?':
    'If I am paid via Platform MyCookAround and want to avoid unnecessary bank transfer fees, how do I do it?',
  //1
  '<ol><li class="li1"><span class="s1">MyCookAround has the easiest possible manipulation. Even elderly people can manage. The User signs to be either a Cook or a Guest. Everyone can be both and switch in their account between Cook &lsquo;s and Guest &lsquo;s profile. Users can log in with an email address, Facebook account or Google account.</span></li><li class="li1"><span class="s1">You must fill all profile details, including a short introduction e.g. &ldquo;Farmer growing the best oranges&rdquo;, &ldquo;Stay at home mother who cooks for her family every day and takes pride in quality of ingredients and likes to meet new people&rdquo; or &ldquo; Single man who loves to cook but hates to eat alone&rdquo;, &bdquo;Farm growing the best organic chickens&ldquo;, and upload a profile picture.</span></li><li class="li1"><span class="s1">Then as a Cook you fill your payment details including payment threshold, in case you choose to be paid out via Platform MyCookAround. It is a tool that saves money on bank transfers where you set minimum amount to receive your pay outs. To receive money you also will be asked for a scan of your ID. Then you create your Offer (plus icon on Cook &lsquo;s profile) &ndash; it can be one portion of any meal you are cooking, several course menu, event, anything you prepare (homemade jam) or grow (one kilogram of oranges) at home or a cooking class where you offer the whole experience to your Guests. You have to upload a picture of your Offer, fill the description, set the price, how many portions/items/seats you have available, date and time of serving/taking place, estimated time of consumption, take away/eat with/both option and your Offer is online. If someone is interested in your Offer, you will get a notification either as a chat request or a direct Order. You can chat with your Guests about an additional questions regarding your Offer (when exactly they come etc.).</span></li><li class="li1"><span class="s1">As a Guest you set filters &ndash; distance from the place where you are located at the moment, price range, time, food restrictions, quantity and in case of meal constumptions if you want to eat with or take away. Also you can use key word search. Then MyCookAround gives you matches with the Offers and you can start browsing. The Offers you like you can easily directly Buy via MyCookAround, or cash at Cook&rsquo;s place or agree with the Cook on any suitable kind of an online payment.</span></li><li class="li1"><span class="s1">After Meal sharing/purchase/experience is due, you can rate under each profile of both Cooks and Guests, which builds trust in the community.</span></li><li class="li1"><span class="s1">When you see that a User on the other side is violating our Terms and Conditions, you can report them.</span></li></ol>':
  `<ol><li class="li1"><span class="s1">MyCookAround has the easiest possible manipulation. Even elderly people can manage. The User signs to be either a Cook or a Guest. Everyone can be both and switch in their account between Cook &lsquo;s and Guest &lsquo;s profile. Users can log in with an email address, Facebook account or Google account.</span></li><li class="li1"><span class="s1">You must fill all profile details, including a short introduction e.g. &ldquo;Farmer growing the best oranges&rdquo;, &ldquo;Stay at home mother who cooks for her family every day and takes pride in quality of ingredients and likes to meet new people&rdquo; or &ldquo; Single man who loves to cook but hates to eat alone&rdquo;, &bdquo;Farm growing the best organic chickens&ldquo;, and upload a profile picture.</span></li><li class="li1"><span class="s1">Then as a Cook you fill your payment details including payment threshold, in case you choose to be paid out via Platform MyCookAround. It is a tool that saves money on bank transfers where you set minimum amount to receive your pay outs. To receive money you also will be asked for a scan of your ID. Then you create your Offer (plus icon on Cook &lsquo;s profile) &ndash; it can be one portion of any meal you are cooking, several course menu, event, anything you prepare (homemade jam) or grow (one kilogram of oranges) at home or a cooking class where you offer the whole experience to your Guests. You have to upload a picture of your Offer, fill the description, set the price, how many portions/items/seats you have available, date and time of serving/taking place, estimated time of consumption, take away/eat with/both option and your Offer is online. If someone is interested in your Offer, you will get a notification either as a chat request or a direct Order. You can chat with your Guests about an additional questions regarding your Offer (when exactly they come etc.).</span></li><li class="li1"><span class="s1">As a Guest you set filters &ndash; distance from the place where you are located at the moment, price range, time, food restrictions, quantity and in case of meal constumptions if you want to eat with or take away. Also you can use key word search. Then MyCookAround gives you matches with the Offers and you can start browsing. The Offers you like you can easily directly Buy via MyCookAround, or cash at Cook&rsquo;s place or agree with the Cook on any suitable kind of an online payment.</span></li><li class="li1"><span class="s1">After Meal sharing/purchase/experience is due, you can rate under each profile of both Cooks and Guests, which builds trust in the community.</span></li><li class="li1"><span class="s1">When you see that a User on the other side is violating our Terms and Conditions, you can report them.</span></li></ol>`,

  //2.1
  '<p>MyCookAround has a strict nondiscrimination policy. MyCookAround is at its core, an open community dedicated to bringing the world closer together by fostering meaningful, shared experiences among people from all parts of the world. Our community includes people from virtually every country on the globe. It is an incredibly diverse community, drawing together individuals of different cultures, values, and norms. The MyCookAround community is committed to building a world where people from every background feel welcome and respected, no matter how far they have traveled from home. This commitment rests on two foundational principles that apply both to MyCookArounds Cooks and Guests inclusion and respect. Our shared commitment to these principles enables every User to feel welcome on MyCookAround no matter who they are, where they come from, how they worship, or whom they love. MyCookAround Cooks welcome Guests of all backgrounds with authentic hospitality and open minds. Joining MyCookAround, as a Cook or Guest, means becoming part of a community of inclusion. Bias, prejudice, racism, and hatred have no place on our platform or in our community. While Cooks are required to follow all applicable laws that prohibit discrimination based on such factors as race, religion, national origin, and others listed below, we commit to do more than comply with the minimum requirements established by law.</p>':
    '<p>MyCookAround has a strict nondiscrimination policy. MyCookAround is at its core, an open community dedicated to bringing the world closer together by fostering meaningful, shared experiences among people from all parts of the world. Our community includes people from virtually every country on the globe. It is an incredibly diverse community, drawing together individuals of different cultures, values, and norms. The MyCookAround community is committed to building a world where people from every background feel welcome and respected, no matter how far they have traveled from home. This commitment rests on two foundational principles that apply both to MyCookArounds Cooks and Guests inclusion and respect. Our shared commitment to these principles enables every User to feel welcome on MyCookAround no matter who they are, where they come from, how they worship, or whom they love. MyCookAround Cooks welcome Guests of all backgrounds with authentic hospitality and open minds. Joining MyCookAround, as a Cook or Guest, means becoming part of a community of inclusion. Bias, prejudice, racism, and hatred have no place on our platform or in our community. While Cooks are required to follow all applicable laws that prohibit discrimination based on such factors as race, religion, national origin, and others listed below, we commit to do more than comply with the minimum requirements established by law.</p>',
  //3
  '<p>All farmers, farms, all homemade food producers or anyone who cooks their meals at home can become a Cook of MyCookAround. Home Cooks can sell one portion of any meal as well a whole event of 5 course menu. Time does not matter. They can sell breakfasts, lunches, dinners or snacks. Also anyone who prepares any kind of food like homemade jams or cookies can sell them via MyCookAround. If you are a farmer grow your own products, MyCookAround is a perfect marketplace for you. If your cooking is really good and you feel confident enough to organize the whole cooking session, you can offer a cooking class. The only limit is the age. You must be over 18 years old.</p>':
    '<p>All farmers, farms, all homemade food producers or anyone who cooks their meals at home can become a Cook of MyCookAround. Home Cooks can sell one portion of any meal as well a whole event of 5 course menu. Time does not matter. They can sell breakfasts, lunches, dinners or snacks. Also anyone who prepares any kind of food like homemade jams or cookies can sell them via MyCookAround. If you are a farmer grow your own products, MyCookAround is a perfect marketplace for you. If your cooking is really good and you feel confident enough to organize the whole cooking session, you can offer a cooking class. The only limit is the age. You must be over 18 years old.</p>',
  //4
  '<p> Only a smartphone, tablet, laptop or a PC to use the Platform. Creating of the profile is doable only via MyCookAround platform and takes approximately 10 minutes. </p>':
    '<p> Only a smartphone, tablet, laptop or a PC to use the Platform. Creating of the profile is doable only via MyCookAround platform and takes approximately 10 minutes. </p>',
  //5
  '<p> It has to be a genuine photo of yourself. As a farm, be it a pic of some of your farmers or he farm. As a private Cook, the best would be a picture in your kitchen when you are cooking or farm where you are working and mainly smiling. </p>':
    '<p> It has to be a genuine photo of yourself. As a farm, be it a pic of some of your farmers or he farm. As a private Cook, the best would be a picture in your kitchen when you are cooking or farm where you are working and mainly smiling. </p>',
  //6
  '<p> Immediately. You don‘t have to wait for any approval. </p>':
    '<p> Immediately. You don‘t have to wait for any approval. </p>',
  //7
  '<p>A powerful, online presence. MyCookAround actively markets your Offers. A dedicated team verifies Guests reviews, making sure they are legitimate. This gives you credibility and helps future Guests make the decision to stay with you. 24/7 support is here for you and your Guests</p>':
    '<p>A powerful, online presence. MyCookAround actively markets your Offers. A dedicated team verifies Guests reviews, making sure they are legitimate. This gives you credibility and helps future Guests make the decision to stay with you. 24/7 support is here for you and your Guests</p>',
  //8
  '<p> It totally depends on you. If you want to increase your sales as a home Cook, the best way is to have planned what you will cook on a specific day and to upload your Offer a few days in advance. If Guests buy fast, you can upload again and set higher amount of portions/seats at table/items available. It is important to find a good balance to have enough time to get ingredients and sell as much as possible in order not to have any waste. And of course the more Offers you upload, the more sales you will make. </p>':
    '<p> It totally depends on you. If you want to increase your sales as a home Cook, the best way is to have planned what you will cook on a specific day and to upload your Offer a few days in advance. If Guests buy fast, you can upload again and set higher amount of portions/seats at table/items available. It is important to find a good balance to have enough time to get ingredients and sell as much as possible in order not to have any waste. And of course the more Offers you upload, the more sales you will make. </p>',
  //9
  '<p> Not at all. If you are good at baking, you can sell your homemade cookies. If you have time only in the morning, you can sell only breakfasts. If you make homemade jams or grow apples, you can sell them. If you want to spend time with your Guests and make more money, you can sell the whole event or a cooking experience. The only condition is homemade food or homemade product. </p>':
    '<p> Not at all. If you are good at baking, you can sell your homemade cookies. If you have time only in the morning, you can sell only breakfasts. If you make homemade jams or grow apples, you can sell them. If you want to spend time with your Guests and make more money, you can sell the whole event or a cooking experience. The only condition is homemade food or homemade product. </p>',
  //10
  '<p> You have to find your balance. You can sell 5 course menu or just one meal or both at the same day. Actually the more Offers you create, the higher your sales will be. You can cook several courses and upload them together and also separately as different Offers. </p>':
    '<p> You have to find your balance. You can sell 5 course menu or just one meal or both at the same day. Actually the more Offers you create, the higher your sales will be. You can cook several courses and upload them together and also separately as different Offers. </p>',
  //11
  '<p> Then you simply set a function “take away” in your Offers. In this case, please always have food containers. The recommendation of MyCookAround is to use paper boxes, which are recyclable. Also there are Guests who bring their own containers, which you can agree on in a chat. </p>':
    '<p> Then you simply set a function “take away” in your Offers. In this case, please always have food containers. The recommendation of MyCookAround is to use paper boxes, which are recyclable. Also there are Guests who bring their own containers, which you can agree on in a chat. </p>',
  //12
  '<p> We have a function where you set your “estimated time of consumption” in every Offer upload. It is up to you if you want to limit the time you spend with your Guests or you want to keep it open. But be aware of a fact that the more time you spend with your Guests, the more you can charge for it. </p>':
    '<p> We have a function where you set your “estimated time of consumption” in every Offer upload. It is up to you if you want to limit the time you spend with your Guests or you want to keep it open. But be aware of a fact that the more time you spend with your Guests, the more you can charge for it. </p>',
  //13
  '<p> How you evaluate your Offers is up to you. If it is one meal Offer, we recommend to set the price per meal a little bit lower than restaurants sell the same meal for. For example, if “spaghetti carbonara” in your neighborhood is sold for 10 Euro, set your price to 8 Euro. If you are a farmer or homemade food producer, sell for the price you sell regularly.  </p>':
    '<p> How you evaluate your Offers is up to you. If it is one meal Offer, we recommend to set the price per meal a little bit lower than restaurants sell the same meal for. For example, if “spaghetti carbonara” in your neighborhood is sold for 10 Euro, set your price to 8 Euro. If you are a farmer or homemade food producer, sell for the price you sell regularly.  </p>',
  //14
  '<p> If there is no regulation in your country that would limit income via online platforms, it totally depends on your activity and will. You can sell one meal per week just not to eat alone when you cook or you can make it your full time business and cook and sell or organize events everyday. If you like the concept of MyCookAround, you can make it your full time business. If you have already an ongoing registered business (farm, homemade food producer), MyCookAround will increase your sales significantly. </p>':
    '<p> If there is no regulation in your country that would limit income via online platforms, it totally depends on your activity and will. You can sell one meal per week just not to eat alone when you cook or you can make it your full time business and cook and sell or organize events everyday. If you like the concept of MyCookAround, you can make it your full time business. If you have already an ongoing registered business (farm, homemade food producer), MyCookAround will increase your sales significantly. </p>',
  //15
  '<p>When you get an Order from a Guest, you get an email notification to the email address you wrote in registration of your profile.</p>':
    '<p>When you get an Order from a Guest, you get an email notification to the email address you wrote in registration of your profile.</p>',
  //16
  '<p> To increase your profits, it is good to follow pricing strategy based on anticipated demand. For instance, times of high demand may lead to higher Offer rates, in order to maximise revenue. When you see that you live in a tourist area and your Friday evening Offers disappear fast, why not make more of them and for a bit higher price? (We still recommend to be cheaper than a restaurant to attract more people). </p>':
    '<p> To increase your profits, it is good to follow pricing strategy based on anticipated demand. For instance, times of high demand may lead to higher Offer rates, in order to maximise revenue. When you see that you live in a tourist area and your Friday evening Offers disappear fast, why not make more of them and for a bit higher price? (We still recommend to be cheaper than a restaurant to attract more people). </p>',
  //17
  '<p>The best way is to set your payment threshold to a certain amount and you will get your payments after you reach it. If you don ‘t set the threshold, you will get your due pay out every Wednesday. </p>':
    '<p>The best way is to set your payment threshold to a certain amount and you will get your payments after you reach it. If you don ‘t set the threshold, you will get your due pay out every Wednesday. </p>',

  //Profile translation
  SEARCH_FOR: 'Search for...',
  'Became a Guest': `Become a Guest`,
  'Became a Cook': `Become a Cook`,
  Profile: `Profile`,
  'Payment Card': `Payment Card`,
  Settings: `Settings`,
  Share: `Share`,
  'Bank Account': `Bank Account`,
  Logout: `Logout`,
  'Contact Support': `Contact Support`,
  'Contact Us': `Contact Us`,
  FAQ: 'FAQ',
  'Terms and Conditions': 'Terms and Conditions',
  'Edit Profile': `Edit Profile`,
  'My Account': 'My Account',
  'Push Notifications': `Push Notifications`,
  'Sign out': 'Sign out',
  'Current Orders': `Current Orders`,
  'Past Orders': `Past Orders`,
  'Newest First': 'Newest First',
  Oldest: 'Oldest',
  'Filter by': 'Filter by',
  'Have any question or need help?': 'Have any question or need help?',
  'Feel free to write us. We will answer you as soon as possible.': `Feel free to write us. We will answer you as soon as possible.`,
  Send: `Send`,
  'My Offer': 'My Offer',
  'User Reviews': 'User Reviews',
  'Meal Details': 'Meal Details',
  'Order Details': 'Order Details',
  'Cannot find offers': 'Cannot find offers',
  'Searching Offers around': 'Searching Offers around',
  Order: 'Order',
  Save: 'Save',
  'Currently you have no past orders': 'Currently you have no past orders',
  'Currently you have no orders': 'Currently you have no orders',
  'Back to my orders': 'Back to my orders',
  'Waiting for Accept': 'Waiting for Accept',
  Refused: 'Refused',
  Ready: 'Ready',
  'Ready in': 'Ready in',
  ARRIVE_IN: 'Arrive in',
  'per item': 'per item',
  Quantity: 'Quantity',
  Available: 'Available',
  'Cooks Details': 'Cooks Details',
  'Guests Details': 'Guests Details',
  'Take away': 'Take away',
  'Eat with': 'Eat with',
  Both: 'Both',
  'Total Price': 'Total Price',
  'Your Payout': 'Your Payout',
  Cook: 'Cook',
  Guest: 'Guest',
  Cooks: 'Cooks',
  Guests: 'Guests',
  'Currently the cooks have no added offer':
    'Currently the cooks have no added offer',
  'Report cook': 'Report Cook',
  'Report guest': 'Report Guest',
  Cancel: 'Cancel',
  'New Offer': 'New Offer',
  General: 'General',
  'Number of items available': 'Number of items available',
  'Price per portion/item': 'Price per portion/item',
  'Date and Time': 'Date and Time',
  CONSUMPTION_TYPE_MESSAGE:
    'Food is available for Eat with, which means the guest has to consume the food at the cooks place',
  NO_OFFER_LISTED: 'You have no offer listed yet',
  Done: 'Done',
  Category: 'Category',
  Select: 'Select',
  Name: 'Name',
  Description: 'Description',
  Restrictions: 'Restrictions',
  'Type of Consumption': 'Type of Consumption',
  TODAY: 'Today',
  YESTEDAY: 'Yesterday',
  RATE_YOUR_GUEST: 'Rate your Guest!',
  RATE_YOUR_COOK: 'Rate your Cook!',
  WRITE_A_NOTE: 'Write a note…',
  CHANGE_PASSWORD: 'Change Password',
  RESET_PASSWORD: 'Reset Password',
  RESET_YOUR_PASSWORD: 'Reset your password',
  RESET_PASSWORD_SUCCESSFUL: 'Your password has been updated successfully.',
  YOUR_EMAIL: `Your Email`,
  WRITE_MESSAGE: 'Write a message',
  DETAILS: 'Details',
  MEAL_NOT_EXISTS: 'Meal does not exist',
  DELETE: 'Delete',
  DELETE_MESSAGE: 'Do you really want to delete this meal?',
  NO_REVIEWS: 'No reviews yet',
  USERNAME: 'Username',
  PHONE_NUMBER: 'Phone Number',
  STREET: 'Street',
  CITY: 'City',
  NOTE: 'Note',
  ZIP_CODE: 'Zip Code',
  REGION: 'Region',
  CONSTANT_OFFER: 'Constant offer',
  Breakfast: 'Breakfast',
  Lunch: 'Lunch',
  Dinner: 'Dinner',
  AVAILABLE_DATES: 'Available Dates',
  VIEW_DATES: 'view available dates',
  NO_DATES: 'no dates available',
  TIME_SCHEDULE: 'Time Schedule',
  NO_TIME_SCHEDULE: 'No Time Schedule',
  'New Card': 'New Card',

  MY_ORDERS: 'My Orders',
  MY_OFFERS: 'My Offers',
  GO_TO_OFFERS: 'Go to My Offers',
  GO_TO_ORDERS: 'Go to My Orders',
  YOUR_OFFER: 'Your Offer',
  WAS_DELETED: 'was deleted by the admin',

  NOTIFICATIONS: 'Notifications',
  NEW_ORDER: 'New Order',
  ORDER_ACCEPTED_NOTIFICATION: 'Order Accepted',
  ORDER_REFUSED_NOTIFICATION: 'Order Refused',
  NEW_ORDER_NOTIFICATION_MESSAGE: 'You have new order request',
  OFFER_DELETED: 'Offer Deleted',
  OFFER_DELETED_NOTIFICATION_MESSAGE: 'Your offer was deleted by the Admin',
  Reason: 'Reason',
  SWITCH_ACCOUNT_MESSAGE: 'Please switch account to view this Order',

  //Modals
  ORDER_ACCEPTED: 'You have accepted the order!',
  Continue: 'Continue',
  ACCEPT: 'Accept',
  REPORT_REASON: 'Your reason has been sent to the guest.',
  'Write a reason of reporting': `Write a reason of reporting`,
  REFUSE_ORDER: 'Refuse Order',
  ACCEPTED_ORDER: 'Your order has been accepted!',
  PICKUP_ADDRESS: 'Pickup your order at the following address at',
  REFUSE_MESSAGE: 'Your order has been refused!',
  ORDER_SENT: 'Your order has been sent!',
  PROSSECCING_TO_COOK: 'Proccessing to the cook',
  SET_VISIBLE: 'You are about to set this meal as invisible.',
  VISIBLE_MESSAGE: `That can be useful, if you know you will cook the meal later in future
  and don’t want to delete it.`,
  DONT_SHOW_AGAIN: `Don't show again`,
  LOGIN_MODAL: 'You need to create an account or login to order!',
  TAKE_A_MOMENT: 'It will only take a moment.',
  NO_CHAT_MESSAGE: 'You do not have any messages yet',
  OFFER_ORDER: 'Order',
  ADD_OFFER: 'Add Offer',
  ADDRESS: 'Address',
  ADDRESS_NOTES: 'Note (floor, apartment number, etc.)',

  'Sending Order': 'Sending Order',
  'Logging in': 'Logging in',
  'accepted order': 'accepted order',
  REPORT_MESSAGE:
    'Thank you for your report. We will investigate it as soon as possible.',
  'Adding Report': 'Adding Report',
  CREATE_PROFILE: 'Create Profile',
  // BUTTONS
  SEND_ORDER: 'Send Order',
  NAVIGATE: 'Navigate',
  SKIP: 'Skip',
  SUBMIT: 'Submit',
  'Signing you up': 'Signing you up',
  'Creating profile': 'Creating profile',

  // AUTHENTICATION
  CREATE_AN_ACCOUNT: 'Create an Account',
  OR_SIGN_IN: 'Or Sign In With',
  EMAIL_LOGIN: 'E-mail Login',
  FACEBOOK_LOGIN: 'Facebook',
  GOOGLE_LOGIN: 'Google',
  LOGIN: 'Login',
  PASSWORD: 'Password',
  PASSWORD_AGAIN: 'Password Again',
  NAME: 'Firstname',
  SURNAME: 'Surname',
  CREATE_ACCOUNT: 'Create Account',
  CREATE: 'Create',
  I_AGREE_WITH: 'I agree with',
  TERMS_AND_CONDITIONS: 'Terms and Conditions',
  FORGOT_PASSWORD: 'Forgot Password',
  FORGOT_YOUR_PASSWORD: 'Forgot your password?',
  TO_RESET_PASSWORD: 'To reset your password please enter your e-mail below.',
  PASSWORD_SENT: 'Password has been sent to your e-mail.',
  ADMIN_LOGIN: 'Login as Admin',
  CREATE_COOK_ACCOUNT: 'Create a Cook account',
  CREATE_GUEST_ACCOUNT: 'Create a Guest account',
  COOKIES:
    'To improve our website and provide a personalised services to you, we would like to store cookies on your device.',
  READ_MORE: ' Read more.',
  IMAGE_NOTE: '*image should be have 400kb max size',

  //Welcome Screen
  GUEST_DESCRIPTION: 'I want to buy delicious meals from various cooks',
  COOK_DESCRIPTION: 'I want to sell my menu and cook it with love for guests',
  GUEST_BUY_DESCRIPTION: 'I want to buy',
  GUEST_SELL_DESCRIPTION: 'I want to sell',
  I_AM_GUEST: `I'm a guest`,
  I_AM_COOK: `I'm a cook`,

  //Date Picker Weekdays
  Mo: 'Mo',
  Tu: 'Tu',
  We: 'We',
  Th: 'Th',
  Fr: 'Fr',
  Sa: 'Sa',
  Su: 'Su',
  //Date Picker Months
  January: 'January',
  February: 'February',
  March: 'March',
  April: 'April',
  May: 'May',
  June: 'June',
  July: 'July',
  August: 'August',
  September: 'September',
  October: 'October',
  November: 'November',
  December: 'December',

  //restriction
  'Dairy Free': 'Dairy Free',
  'Gluten Free': 'Gluten Free',
  Halal: 'Halal',
  Kosher: 'Kosher',
  'Nut Free': 'Nut Free',
  Organic: 'Organic',
  Vegan: 'Vegan',
  Vegetarian: 'Vegetarian',
  'Low Carb': 'Low Carb',
  Fitness: 'Fitness',
  'Sugar Free': 'Sugar Free',
  Paleo: 'Paleo',
  GENERAL: 'General',

  //ERROR HANDLER
  INPUT_FIRST_NAME: 'Please input your First name!',
  INPUT_LAST_NAME: 'Please input your Last name!',
  INPUT_USERNAME: 'Please input your username!',
  INPUT_DESCRIPTION: 'Please input your description!',
  INPUT_PHONE_NUMBER: 'Please input your Phone Number!',
  INPUT_STREET: 'Please input Street!',
  INPUT_CITY: 'Please input City!',
  TIME_ERROR: 'Time must be greater than the current time.',
  CONSUMPTION_ERROR: 'Please select Consumption Type',
  DATE_ERROR: 'Please select Date and Time',
  IMAGE_UPLOAD_ERROR: 'Please upload an image',
  MEAL_NAME_ERROR: 'Please fill Meal name!',
  MEAL_DESCRIPTION_ERROR: 'Please fill Meal Description!',
  PRICE_ERROR: 'Please input Price',
  RESCTRICTED_MESSAGE: 'You have entered some restricted words.',

  // SUCCESS HANDLER
  'Profile Updated': 'Profile Updated',
  'Something went wrong': 'Something went wrong',
  //meal filter
  'Meal Filter': 'Meal Filter',
  Filter: 'Filter',
  LOCATION: 'Location',
  NEAREST: 'Nearest',
  FROM: 'From',
  TO: 'To',
  SET: 'Set',
  MAX_PRICE: 'Max price',

  //update profile
  EDIT_PROFILE_HEADER_COOK: 'Create Profile as Cook',
  EDIT_PROFILE_HEADER_GUEST: 'Create Profile as Guest',

  //Edit meal
  'Edit Offer': 'Edit Offer',
  'Editing Offer': 'Editing Offer',
  MAX_TIME: 'Max-time',
  //Edit meal error
  FILL_TITLE: 'Please fill Meal name!',
  FILL_DESCRIPTION: 'Please fill Meal Description!',
  FILL_PRICE: 'Please input Price',

  // PRODUCT CATEGORIES
  'Jams and marmelades': 'Jams and marmelades',
  'Dried fruits and vegetables': 'Dried fruits and vegetables',
  'Fresh fruits and vegetables': 'Fresh fruits and vegetables',
  'Pickled fruits and vegetables': 'Pickled fruits and vegetables',
  'Legumes(beans, lents...etc.)': 'Legumes(beans, lents...etc.)',
  Mushrooms: 'Mushrooms',
  'Fruit syrups and lemonade': 'Fruit syrups and lemonade',

  'Cakes and sweets': 'Cakes and sweets',
  Puddings: 'Puddings',
  Chocolate: 'Chocolate',
  'Ice creams': 'Ice creams',
  'Bakery products and pastry': 'Bakery products and pastry',

  'Diary products(butter, cheese, milk, yogurt...etc.)':
    'Diary products(butter, cheese, milk, yogurt...etc.)',
  Honey: 'Honey',
  Oils: 'Oils',
  Eggs: 'Eggs',

  Grains: 'Grains',
  'Seeds, cereals and nuts': 'Seeds, cereals and nuts',
  'Spices and Seasonings': 'Spices and Seasonings',
  'Tea and herbal tea': 'Tea and herbal tea',
  Herbs: 'Herbs',
  'Herbal syrups and lemonade': 'Herbal syrups and lemonade',

  'Smoked meats, hams and sausages': 'Smoked meats, hams and sausages',
  'Pesto, sauce and dressings': 'Pesto, sauce and dressings',

  'Beer, vino and destillate': 'Beer, vino and destillate',

  'Ready meals': 'Ready meals',

  Appetizers: 'Appetizers',
  'Bread spread': 'Bread spread',
  Pasta: 'Pasta',
  'Pizza and focaccia': 'Pizza and focaccia',
  'Fish, sea fruit and shellfish': 'Fish, sea fruit and shellfish',
  'Meat, steaks and venison': 'Meat, steaks and venison',
  'Steamed food': 'Steamed food',
  'Grilled and charcoaled food': 'Grilled and charcoaled food',
  'Roasted food': 'Roasted food',
  Salads: 'Salads',
  Soups: 'Soups',

  'Home made natural products': 'Home made natural products',
  'Home made tinctures': 'Home made tinctures',

  Experience: 'Experience',

  'Pet food': 'Pet food',

  // CARDS AND BANK DETAILS
  PAYMENT_CARD: 'Payment Card',
  NEW_CARD: 'New Card',
  BANK_ACCOUNT: 'Bank account',
  NEW_ACCOUNT: 'New Account',
  ACCOUNT_DETAILS: 'Account Details',

  CARD_DETAILS: 'Card Details',
  CARD_NUMBER: 'Card Number',
  CARDHOLDER_NAME: `Holder's Name`,
  IBAN: 'IBAN',
  ACCOUNT_NUMBER: 'Account Number',
  SWIFT_CODE: `SWIFT Code/ BIC`,
  BANK_NAME: 'Bank Name',
  BANK_ADDRESS: 'Bank Address',

  EMPTY_PAYMENT_CARDS: `You haven't added any cards.`,
  EMPTY_BANK_ACCOUNT: `You haven't added an account.`,
  DELETE_THIS_CARD: 'Do you really want to delete this card?',
  PAYMENT_THRESHOLD: 'Payment Threshold',
  PAYMENT_THRESHOLD_MESSAGE:
    'You will receive payment when the amount owed exceeds the specified threshold.',

  INVALID_CARD_NUMBER: 'Invalid card number',
  INVALID_CARD_EXPIRATION: 'Invalid card expiration date',
  INVALID_CVV: 'CVV card is invalid',

  INPUT_HOLDERS_NAME: `Please input Holder's Name!`,
  INPUT_ACCOUNT_NUMBER: `Please input Account Number!`,
  INPUT_IBAN: 'Please input IBAN!',
  INPUT_SWIFT_CODE: 'Please input SWIFT Code/BIC!',
  INPUT_BANK_NAME: 'Please input Bank Name!',
  INPUT_BANK_ADDRESS: 'Please input Bank Address!',
  INPUT_PAYMENT_THRESHOLD: 'Please input Payment Threshold!',

  //Change Password
  STAY_LOGGED: 'Stay logged in',
  CURRENT_PASSWORD: 'Current Password',
  NEW_PASSWORD: 'New Password',
  PASSWORD_INVALID: 'The current password is invalid.',
  PASSWORD_CHARACTERS: 'Password should be atleast 6 characters.',
};

export default translationEng;
